import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import ClientHeader from '../ClientHeader';
import ClientFooter from '../ClientFooter';

/**
 * Public marketing shell (homepage, browse, auth entry).
 * Uses .theme-marketing — separate from product-app density.
 */
const ClientLayout = () => {
  const { pathname } = useLocation();
  const hideFooter =
    pathname === '/browse' ||
    pathname.startsWith('/browse-vendors') ||
    pathname.startsWith('/search') ||
    pathname.startsWith('/category/');

  return (
    <div className="theme-marketing marketing-app flex min-h-screen flex-col">
      <ClientHeader />
      <main className="relative flex-1">
        <Outlet />
      </main>
      {hideFooter ? null : <ClientFooter />}
    </div>
  );
};

export default ClientLayout;
